import isNumeric from 'utils/number/isNumeric';

/**
 * Returns a function that is usable in a sort operation for sorting table rows.
 * @param {object} options - Options to use when sorting.
 * @param {string} options.column - The column to sort by.
 * @param {string} options.dir - One of 'ASC', 'DESC'.
 * @returns {function} - A function to use as an Array.sort callback.
 */
export default function tableSort({ column, dir = 'ASC' }) {
  /**
   * A function to be used as an Array.sort callback to sort table data.
   * @param {object} rowA - The first row to compare.
   * @param {object} rowB - The second row to compare.
   * @returns {number} - -1 if A is first, 1 if B is first, 0 otherwise.
   */
  return (rowA, rowB) => {
    // Handle pinned values.
    if (rowA.pin && !rowB.pin) {
      return -1;
    } else if (rowB.pin && !rowA.pin) {
      return 1;
    }

    // Negotiate values.
    const valA = rowA.data[column] && rowA.data[column].formattedValue ?
      rowA.data[column].formattedValue :
      'n/a';
    const valB = rowB.data[column] && rowB.data[column].formattedValue ?
      rowB.data[column].formattedValue :
      'n/a';

    // Handle equality.
    if (valA === valB) {
      return 0;
    }

    // Handle nulls.
    if ('n/a' === valB) {
      return -1;
    } else if ('n/a' === valA) {
      return 1;
    }

    // Compute sort direction inverter.
    const inverter = 'ASC' === dir ? 1 : -1;

    // Handle numeric comparison.
    const valANumeric = parseFloat(valA.replace(/[^0-9.]/g, ''));
    const valBNumeric = parseFloat(valB.replace(/[^0-9.]/g, ''));
    if (isNumeric(valANumeric) && isNumeric(valBNumeric)) {
      if (valANumeric < valBNumeric) {
        return -1 * inverter;
      } else if (valANumeric > valBNumeric) {
        return inverter;
      }

      return 0;
    }

    // Fall back to string comparison.
    return valA.localeCompare(valB) * inverter;
  };
}



// WEBPACK FOOTER //
// ./app/services/tableSort.js